module.exports = __webpack_public_path__ + "static/media/0146_Medium.53c1213b.jpg";